<template>
   <intersect @enter="animate = true">
    <div class="similarProjects container">
      <div
        class="mainTtl noto-semibold fadeUp"
        :class="animate ? 'animate' : ''"
        v-if="similarItems.length && _.get(itemData, 'secondary.SimilarDeveloperProjects.conf.useHeader') == 1"
      >{{_.get(itemData, 'secondary.SimilarDeveloperProjects.conf.header.title')}}</div>

      <div
        class="descr fadeUp"
        :class="animate ? 'animate' : ''"
        v-if="similarItems.length && _.get(itemData, 'secondary.SimilarDeveloperProjects.conf.useHeader') == 1"
      >{{_.get(itemData, 'secondary.SimilarDeveloperProjects.conf.header.teaser')}}</div>

      <div class="similarProjectsOut">
        <div class="partner-cards">
          <router-link :to="$store.getters.getSingleUrl(partner, 1)" 
            class="partner-card fadeUp" 
            :class="animate ? 'animate' : ''"
            v-for="(partner, index) in similarItems" :key="index">
              <div class="partner-image">
                <picture>
                  <source media="(max-width: 767px)" :srcset="_.get(partner, 'list_cover.0.devices.mobile')" />
                  <source media="(max-width: 1023px)" :srcset="_.get(partner, 'list_cover.0.devices.tablet')" />
                  <img v-if="_.get(partner, 'list_cover.0.devices.desktop')" :src="_.get(partner, 'list_cover.0.devices.desktop')" class="img-absolute" :alt="partner.title" />
                </picture>
              </div>

              <div class="partner-content">
                <!-- {{ $store.state.locale }} -->
                <div class="partner-logo">
                  <img v-if="_.get(partner , 'logo')" :src="_.get(partner , 'logo.0.url')" :alt="partner.title" />
                </div>
                
                <div class="partner-text">
                  <div class="partner-developer">
                    <template v-for="(dev, index) in getDevelopers(partner.developers)">
                      <span v-if="index">-</span>
                      <span>
                        {{ dev.title }}
                      </span>
                    </template>
                  </div>

                  <h2 class="partner-title noto-semibold">{{ partner.title }}</h2>

                  <div class="partner-teaser">{{ partner.teaser }}</div>
                </div>
              </div>
          </router-link>
        </div>
      </div>
    </div>
  </intersect>
</template>
<script>
import SmartButton from "./modules/SmartButton";
import Intersect from 'vue-intersect'
export default {
  components: {
    SmartButton,
    Intersect
  },
  props: ["itemData", "titleData"],
  data() {
    return {
      animate: false,
      similarItems: [],
    };
  },
  computed: {
    developers() {
      return _.get(this.$store.state.indx, 'terms.developers')
    },
  },
  methods: {
    getDevelopers(ids) {
      if (this.developers.length) {
        return this.developers.filter(x => ids.includes(x.id))
      }

      return []
    },
    async getSimilarItems() {
      const params = {
        content_type: "partner_developers",
        taxonomy: "developers_location",
        term: _.get(this.itemData, 'primary.0.developers_location'),
        exclude: _.get(this.itemData, 'primary.0.id'),
      }

      let res = await this.$fn.postData('main/getDataList2', params);

      if (res.status == 200) {
        this.similarItems = res.data.list || [];
      }
    },
  },
  beforeMount() {
    this.getSimilarItems();
  },
};
</script>

<style>
.similarProjects {
  padding-top: 80px;
  position: relative;
}

.similarProjects .mainTtl {
  font-size: 34px;
  line-height: 60px;
}

.reasonsSliderContainer .descr {
  width: 40%;
}

.similarProjectsOut {
  margin-top: 50px;
}
</style>
